import * as React from 'react';

import styles from './TextMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessage } from '../../../ChatMessage';
import { MetaRow } from '../MetaRow';

interface ITextMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  userName: React.ReactNode;
  textMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
  replyQuote?: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const TextMessageLayout = React.forwardRef<HTMLDivElement, ITextMessageLayoutProps>(function TextMessageLayout(
  {
    errorSign,
    errorText,
    messageType,
    isLastMessageInChain,
    userName,
    textMessage,
    messageMeta,
    actionButtons,
    userColor,
    replyQuote,
    highlighted,
    onHighlightEnd,
  },
  ref,
) {
  return (
    <ChatMessage errorSign={errorSign} errorText={errorText}>
      <ChatMessageBubble
        messageType={messageType}
        withTail={isLastMessageInChain}
        className={styles['text-message__bubble']}
        ref={ref}
        userColor={userColor}
        highlighted={highlighted}
        onHighlightEnd={onHighlightEnd}
      >
        {userName}
        {replyQuote}
        {textMessage}
        {actionButtons}
        <MetaRow messageType={messageType} userColor={userColor}>
          {messageMeta}
        </MetaRow>
      </ChatMessageBubble>
    </ChatMessage>
  );
});
